// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__2FNCe","warning":"style_warning__cR8yf","BackgroundImg":"style_BackgroundImg__oQ7wF"};